import { Component, input, InputSignal, output, OutputEmitterRef, signal, WritableSignal } from '@angular/core';
import { PlanogramChatComponent } from '../planogram-chat/planogram-chat.component';
import { SHARED_MODULES } from '../../../shared.';
import { MixpanelService } from '../../services/mixpanel.service';
import { MixpanelEvents } from '../../models/mixpanelEvents';
import { ChatService } from '../../services/chat.service';

@Component({
    selector: 'app-planogram-chat-drawer',
    templateUrl: './planogram-chat-drawer.component.html',
    styleUrls: ['./planogram-chat-drawer.component.scss'],
    imports: [...SHARED_MODULES, PlanogramChatComponent]
})
export class PlanogramChatDrawerComponent {

    opened: WritableSignal<boolean> = signal<boolean>(false);
    focusMessageId: WritableSignal<number> = signal<number>(-1);

    planogramName: InputSignal<string> = input<string>('');
    closeIcon: InputSignal<string> = input<string>('close');

    close: OutputEmitterRef<void> = output<void>();

    constructor(private mixpanelService: MixpanelService, private chatService: ChatService) {}

    onOpen(entryPoint: 'planogram' | 'all_chats', focusMessageId?: number): void {
        this.opened.set(true);
        this.mixpanelService.trackPage(MixpanelEvents.ChatOpened, {
            entry_point: entryPoint
        });
        this.chatService.focusMessageId.set(focusMessageId);
    }

    onClose(): void {
        this.opened.set(false);
        this.close.emit();
        this.chatService.focusMessageId.set(null);
    }
}